var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.666 11.8333C32.666 12.5697 32.0691 13.1667 31.3327 13.1667L12.666 13.1667C11.9296 13.1667 11.3327 12.5697 11.3327 11.8333C11.3327 11.097 11.9296 10.5 12.666 10.5L31.3327 10.5C32.0691 10.5 32.666 11.097 32.666 11.8333Z",
    fill: "#0B0B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.666 33.1667C32.666 33.903 32.0691 34.5 31.3327 34.5L12.666 34.5C11.9296 34.5 11.3327 33.903 11.3327 33.1667C11.3327 32.4303 11.9296 31.8333 12.666 31.8333L31.3327 31.8333C32.0691 31.8333 32.666 32.4303 32.666 33.1667Z",
    fill: "#0B0B17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3899 24.7761L13.0565 23.4428C12.5358 22.9221 12.5358 22.0779 13.0565 21.5572C13.5772 21.0365 14.4215 21.0365 14.9422 21.5572L15.3327 21.9477L17.0565 20.2239C17.5772 19.7032 18.4215 19.7032 18.9422 20.2239C19.4629 20.7446 19.4629 21.5888 18.9422 22.1095L16.2755 24.7761C15.7548 25.2968 14.9106 25.2968 14.3899 24.7761Z",
    fill: "#0B0B17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9993 21.1667C21.263 21.1667 20.666 21.7636 20.666 22.5C20.666 23.2364 21.263 23.8333 21.9993 23.8333H29.9993C30.7357 23.8333 31.3327 23.2364 31.3327 22.5C31.3327 21.7636 30.7357 21.1667 29.9993 21.1667H21.9993Z",
    fill: "#0B0B17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 14.5C11.0538 14.5 8.66602 16.8878 8.66602 19.8333V25.1667C8.66602 28.1122 11.0538 30.5 13.9993 30.5H29.9993C32.9449 30.5 35.3327 28.1122 35.3327 25.1667V19.8333C35.3327 16.8878 32.9449 14.5 29.9993 14.5H13.9993ZM11.3327 19.8333C11.3327 18.3606 12.5266 17.1667 13.9993 17.1667H29.9993C31.4721 17.1667 32.666 18.3606 32.666 19.8333V25.1667C32.666 26.6394 31.4721 27.8333 29.9993 27.8333H13.9993C12.5266 27.8333 11.3327 26.6394 11.3327 25.1667V19.8333Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenSecurity);
export default __webpack_public_path__ + "static/media/token-security.2e558355b6fc7f7a60be73e012a23bbd.svg";
export { ForwardRef as ReactComponent };